import {Button, Flex, Text} from '@chakra-ui/react'
import PropTypes from 'prop-types'

const ButtonWithIcon = ({
  text,
  icon,
  onClick,
  href,
  disabled,
  variant,
  ...props
}) => {
  const downloadUrl = href ? new URL(href, window.location.origin) : null

  return (
    <Button
      as={href ? 'a' : 'button'}
      variant={variant}
      rounded="full"
      border="1px solid black"
      onClick={onClick}
      href={href && `${downloadUrl.toString()}`}
      disabled={disabled}
      cursor={disabled ? 'not-allowed' : 'pointer'}
      opacity={disabled ? 0.6 : 1}
      {...props}
    >
      <Flex gap={2}>
        <Text textTransform="uppercase">{text}</Text>
        {icon}
      </Flex>
    </Button>
  )
}

ButtonWithIcon.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  variant: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  href: PropTypes.string,
  disabled: PropTypes.bool,
}

ButtonWithIcon.defaultProps = {
  onClick: null,
  href: null,
  disabled: false,
}

export default ButtonWithIcon
